import React from 'react';
import './question.scss';
import RadioInput from '../../components/RadioButton';
import Button from '../../components/Button';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateForm } from '../../core/actions';
import { RootState } from '../../core/app_state_config';

interface QuestionOption {
    label: string;
    score: number;
}

interface QuestionProps {
    name: string;
    route: string;
    label: string;
    text: string;
    options: QuestionOption[];
}

const Question: React.FC<QuestionProps> = ({ label, name, text, route, options }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const form = useSelector((state: RootState) => state.app).form;
    const [response, setResponse] = React.useState<any>(null);

    React.useEffect(() => {
        setResponse(form[name]?.value);
        return;
    }, [name, form]);
    
    function onChanged(value: any) {
        setResponse(value);
    }
    function onSubmitted() {
        const _option: any = options.find(option => option.label.replaceAll(' ', '_') === response);
        dispatch(updateForm(name, { value: response, score: _option.score }));
        navigate(route, { replace: true });
    }
    return (
        <div className="question">
            <h4 className="question__title">{label}</h4>
            <h1 className="question__subtitle">{text}</h1>
            {options.map((option: QuestionOption) => {
                const id = option.label.replace(' ', '-');
                const _name = option.label.replaceAll(' ', '_');
                return <RadioInput
                    key={id}
                    id={id}
                    label={option.label}
                    value={_name}
                    groupValue={response}
                    onChange={onChanged}
                />
            })}
            <div style={{ marginTop: 16 }}>
                <Button type='primary' onPressed={onSubmitted} disabled={!response}>
                    {'Continue'}
                </Button>
            </div>
        </div>
    );
}

export default Question;
